/**
 * Central SEO Configuration for all pages
 * This file defines meta tags, titles, and descriptions for each route
 */

const SITE_URL = 'https://hvkurz.de';
const COMPANY_NAME = 'Scholze-Kurz & Kurz Immobilien GmbH';
const DEFAULT_IMAGE = 'https://hvkurz.de/images/buero-mainz.png';

export const seoConfig = {
  // Homepage
  '/': {
    title: 'Hausverwaltung Wiesbaden seit 1981 | Scholze-Kurz & Kurz',
    description: 'Ihre Hausverwaltung in Wiesbaden, Mainz und dem Rhein-Main-Gebiet — Zertifizierter Verwalter (IHK) gemäß § 26a WEG. WEG-Verwaltung, Mietverwaltung und Sondereigentumsverwaltung. Persönlich, kompetent, zuverlässig.',
    keywords: 'Hausverwaltung Wiesbaden, WEG-Verwaltung, Mietverwaltung, Sondereigentumsverwaltung, Immobilienverwaltung Mainz, Hausverwaltung Rhein-Main',
    canonical: SITE_URL,
  },

  // Service Pages
  '/weg-verwaltung': {
    title: 'WEG-Verwaltung im Rhein-Main-Gebiet | Scholze-Kurz & Kurz',
    description: 'Professionelle WEG-Verwaltung für Ihre Eigentümergemeinschaft. Eigentümerversammlungen, Wirtschaftspläne, Instandhaltung. Zertifizierter Verwalter (IHK) gemäß § 26a WEG — seit 1981.',
    keywords: 'WEG-Verwaltung, WEG-Verwalter, Wohnungseigentümergemeinschaft, WEG-Verwaltung Wiesbaden, WEG-Verwaltung Mainz',
    canonical: `${SITE_URL}/weg-verwaltung`,
  },

  '/mietverwaltung': {
    title: 'Mietverwaltung Wiesbaden & Mainz | Scholze-Kurz & Kurz',
    description: 'Professionelle Mietverwaltung für Ihre Mietimmobilie. Mietersuche, Nebenkostenabrechnung, Instandhaltung. Maximieren Sie Ihre Rendite.',
    keywords: 'Mietverwaltung, Mietverwaltung Wiesbaden, Mietverwaltung Mainz, Miethaus Verwaltung, Renditeoptimierung',
    canonical: `${SITE_URL}/mietverwaltung`,
  },

  '/sondereigentumsverwaltung': {
    title: 'Sondereigentumsverwaltung | Scholze-Kurz & Kurz',
    description: 'Individuelle Verwaltung Ihrer Eigentumswohnung als Kapitalanlage. Wir übernehmen alle Vermieterpflichten und maximieren Ihre Rendite.',
    keywords: 'Sondereigentumsverwaltung, SEV Verwaltung, Eigentumswohnung vermieten, Kapitalanlage Wohnung',
    canonical: `${SITE_URL}/sondereigentumsverwaltung`,
  },

  '/facility': {
    title: 'Facility Management & Dienstleistungen | Scholze-Kurz & Kurz',
    description: 'Umfassende Facility-Services für Ihre Immobilie: Hausmeisterservice, Winterdienst, Gartenpflege und technische Betreuung.',
    keywords: 'Facility Management, Hausmeisterservice, Winterdienst, Gebäudemanagement, Immobiliendienstleistungen',
    canonical: `${SITE_URL}/facility`,
  },

  // Location Pages
  '/hausverwaltung-wiesbaden': {
    title: 'Hausverwaltung Wiesbaden | WEG & Mietverwaltung seit 1981',
    description: 'Ihre lokale Hausverwaltung in Wiesbaden. WEG-Verwaltung, Mietverwaltung, Sondereigentum. Persönlich, transparent und zuverlässig.',
    keywords: 'Hausverwaltung Wiesbaden, WEG-Verwaltung Wiesbaden, Mietverwaltung Wiesbaden, Immobilienverwaltung Wiesbaden',
    canonical: `${SITE_URL}/hausverwaltung-wiesbaden`,
  },

  '/hausverwaltung-mainz': {
    title: 'Hausverwaltung Mainz | WEG & Mietverwaltung | HV Kurz',
    description: 'Professionelle Hausverwaltung in Mainz und Umgebung. WEG-Verwaltung, Mietverwaltung und Sondereigentum. Büro in Mainz-Kostheim.',
    keywords: 'Hausverwaltung Mainz, WEG-Verwaltung Mainz, Mietverwaltung Mainz, Hausverwaltung Kostheim',
    canonical: `${SITE_URL}/hausverwaltung-mainz`,
  },

  '/hausverwaltung-rhein-main': {
    title: 'Hausverwaltung Rhein-Main-Gebiet | Scholze-Kurz & Kurz',
    description: 'Ihre Hausverwaltung für das gesamte Rhein-Main-Gebiet. WEG-Verwaltung, Mietverwaltung in Frankfurt, Wiesbaden, Mainz und Umgebung.',
    keywords: 'Hausverwaltung Rhein-Main, WEG-Verwaltung Frankfurt, Immobilienverwaltung Rhein-Main-Gebiet',
    canonical: `${SITE_URL}/hausverwaltung-rhein-main`,
  },

  '/hausverwaltung-idstein': {
    title: 'Hausverwaltung Idstein | Scholze-Kurz & Kurz',
    description: 'Hausverwaltung für Idstein und den Taunus. WEG-Verwaltung und Mietverwaltung mit regionaler Expertise.',
    keywords: 'Hausverwaltung Idstein, WEG-Verwaltung Idstein, Mietverwaltung Taunus',
    canonical: `${SITE_URL}/hausverwaltung-idstein`,
  },

  '/hausverwaltung-hochheim': {
    title: 'Hausverwaltung Hochheim am Main | Scholze-Kurz & Kurz',
    description: 'Professionelle Hausverwaltung in Hochheim am Main. WEG-Verwaltung und Mietverwaltung mit persönlicher Betreuung.',
    keywords: 'Hausverwaltung Hochheim, WEG-Verwaltung Hochheim, Mietverwaltung Hochheim am Main',
    canonical: `${SITE_URL}/hausverwaltung-hochheim`,
  },

  // Other important pages
  '/kontakt': {
    title: 'Kontakt & Anfrage | Hausverwaltung Scholze-Kurz & Kurz',
    description: 'Kontaktieren Sie uns für ein unverbindliches Angebot. Büros in Wiesbaden (Gaugasse 19) und Mainz-Kostheim. Tel: 0611 - 60 33 13.',
    keywords: 'Hausverwaltung Kontakt, Verwaltungsanfrage, Hausverwaltung Wiesbaden Telefon',
    canonical: `${SITE_URL}/kontakt`,
  },

  '/verwalter-wechseln': {
    title: 'Verwalter wechseln | Ratgeber WEG-Verwaltungswechsel',
    description: 'Sie möchten Ihren WEG-Verwalter wechseln? Unser Ratgeber erklärt den Ablauf, Fristen und was Sie beachten müssen.',
    keywords: 'Verwalter wechseln, Verwalterwechsel WEG, neuer Hausverwalter, Hausverwaltung kündigen',
    canonical: `${SITE_URL}/verwalter-wechseln`,
  },

  '/referenzen': {
    title: 'Referenzen | Verwaltete Objekte | Scholze-Kurz & Kurz',
    description: 'Unsere Referenzen: Verwaltete Liegenschaften in Wiesbaden, Mainz und dem Rhein-Main-Gebiet. WEG und Mietobjekte.',
    keywords: 'Hausverwaltung Referenzen, verwaltete Objekte, Kundenstimmen Hausverwaltung',
    canonical: `${SITE_URL}/referenzen`,
  },

  '/aktuelles': {
    title: 'Aktuelles & Blog | Hausverwaltung Scholze-Kurz & Kurz',
    description: 'Neuigkeiten, Ratgeber und aktuelle Informationen rund um WEG-Verwaltung, Mietrecht und Immobilien im Rhein-Main-Gebiet.',
    keywords: 'Hausverwaltung Blog, WEG Ratgeber, Mietrecht Aktuelles, Immobilien News',
    canonical: `${SITE_URL}/aktuelles`,
  },

  '/ankauf-verkauf': {
    title: 'Immobilien Ankauf & Verkauf | Scholze-Kurz & Kurz',
    description: 'Wir kaufen Mehrfamilienhäuser in Wiesbaden, Mainz und Umgebung. Kaufzusage in 5 Werktagen. Oder verkaufen Sie provisionsfrei.',
    keywords: 'Immobilien kaufen, Mehrfamilienhaus verkaufen, Immobilienankauf Wiesbaden',
    canonical: `${SITE_URL}/ankauf-verkauf`,
  },

  '/impressum': {
    title: 'Impressum | Scholze-Kurz & Kurz Immobilien GmbH',
    description: 'Impressum der Scholze-Kurz & Kurz Immobilien GmbH, Hausverwaltung in Wiesbaden.',
    canonical: `${SITE_URL}/impressum`,
    noindex: true,
  },

  '/datenschutz': {
    title: 'Datenschutzerklärung | Scholze-Kurz & Kurz',
    description: 'Datenschutzerklärung der Scholze-Kurz & Kurz Immobilien GmbH gemäß DSGVO.',
    canonical: `${SITE_URL}/datenschutz`,
    noindex: true,
  },
};

/**
 * Get SEO config for a specific path
 * Falls back to default values if path not found
 */
export const getSeoConfig = (path) => {
  const config = seoConfig[path];
  
  if (config) return config;
  
  // Default fallback
  return {
    title: `${COMPANY_NAME} | Hausverwaltung Wiesbaden`,
    description: 'Professionelle Hausverwaltung in Wiesbaden und dem Rhein-Main-Gebiet. WEG-Verwaltung, Mietverwaltung und Sondereigentumsverwaltung.',
    canonical: `${SITE_URL}${path}`,
  };
};

/**
 * FAQ data for FAQ Schema markup
 * Used on pages with FAQ sections
 */
export const faqData = {
  '/hausverwaltung-wiesbaden': [
    {
      question: 'Was kostet eine Hausverwaltung in Wiesbaden?',
      answer: 'Die Kosten einer Hausverwaltung in Wiesbaden hängen von Objektart und Größe ab. Bei WEG-Verwaltungen rechnen wir mit 25–45 € pro Einheit und Monat ab. Mietverwaltung erfolgt prozentual zur Bruttomiete (4,5–6 %), Sondereigentumsverwaltung mit 40–65 € pro Einheit. Die Erstberatung inkl. Objektbegehung in Wiesbaden ist kostenfrei.'
    },
    {
      question: 'Wie läuft ein Verwalterwechsel in Wiesbaden ab?',
      answer: 'Nach Beschluss der Eigentümerversammlung übernehmen wir die komplette Abwicklung: Kündigung des Altverwalters, Übernahme aller Unterlagen, Einrichtung der Konten und persönliche Vorstellung. Der gesamte Wechsel dauert üblicherweise 4–8 Wochen. Von unserem Hauptsitz in Wiesbaden-Biebrich aus sind wir in alle Wiesbadener Stadtteile schnell vor Ort.'
    },
    {
      question: 'Welche Stadtteile in Wiesbaden hat Scholze-Kurz im Bestand?',
      answer: 'Wir verwalten Liegenschaften in ganz Wiesbaden und der Region – mit Schwerpunkten in der Innenstadt/Mitte, Biebrich, Dotzheim, Westend/Rheingauviertel, Erbenheim, Nordenstadt/Delkenheim, Sonnenberg und Schierstein. Auch in Erbsberg, Frauenstein, Heßloch und Klarenthal sind wir vereinzelt tätig.'
    },
    {
      question: 'Wie lange dauert ein Verwalterwechsel in Wiesbaden?',
      answer: 'Der gesamte Prozess dauert vom Beschluss in der Eigentümerversammlung bis zur produktiven Übernahme typischerweise 4–8 Wochen. Bei dringendem Wechsel können wir die Übernahme auch innerhalb von 14 Tagen durchführen. Da wir IHK Wiesbaden zertifiziert sind und alle relevanten Behörden vor Ort kennen (Amtsgericht, Bauamt, ESWE), läuft die Umstellung reibungslos.'
    },
    {
      question: 'Welche hessischen Förderprogramme nutzen Sie für Sanierungen?',
      answer: 'Bei Sanierungen in Wiesbaden setzen wir auf Förderprogramme der WIBank (Wirtschafts- und Infrastrukturbank Hessen) sowie der KfW. Beliebt sind die Hessische Energiesparberatung, KfW 261/262 (Energieeffizienzhaus) und das hessische Programm „Klimaprämie Bestand". Wir stellen die Anträge in Abstimmung mit den Eigentümern und arbeiten eng mit ortsansässigen Energieberatern in Wiesbaden zusammen.'
    },
    {
      question: 'Bieten Sie auch Verwaltung für Neubauten in Wiesbaden an?',
      answer: 'Ja, wir übernehmen Erstverwaltungen von Neubau-WEGs in Wiesbaden — z. B. in Erbenheim, Nordenstadt und Delkenheim. Wir begleiten den Prozess ab der Bauphase: Bauträger-Kommunikation, Erstabnahmen, werdende WEG, erste Eigentümerversammlung. Aktuell verwalten wir mehrere KfW-55-Quartiere mit bis zu 32 Einheiten.'
    },
    {
      question: 'Wie weit ist Ihr Büro vom Wiesbadener Hauptbahnhof entfernt?',
      answer: 'Unser Hauptsitz Gaugasse 19 liegt im Quartier Gibb in Wiesbaden-Biebrich – mit dem Auto ca. 7 Minuten zum Hauptbahnhof, 8 Minuten in die Innenstadt und nur 5 Minuten zu Fuß zu Schloss Biebrich und Rheinufer. Über die A66 (Anschluss Wiesbaden-Biebrich) sind alle Wiesbadener Stadtteile sowie Mainz-Kostheim in 6–18 Minuten erreichbar.'
    },
    {
      question: 'Sind Sie als Hausverwaltung Wiesbaden IHK-geprüfter Verwalter gemäß § 26a WEG?',
      answer: 'Ja, unser Verwalter-Zertifikat „Zertifizierter Verwalter (IHK)" nach § 26a WEG haben wir bei der IHK Wiesbaden (Wilhelmstraße 24-26) erworben. Wir nehmen regelmäßig an Weiterbildungen zu Hessischem Bauordnungsrecht, Denkmalschutz und WEG-Reform teil. Zusätzlich sind wir nach § 34c GewO bei der Stadt Wiesbaden gewerblich zugelassen und haben eine Vermögensschadenhaftpflicht über die ERGO Versicherung.'
    },
    {
      question: 'Wie erreiche ich meinen Ansprechpartner?',
      answer: 'Telefonisch sind wir Mo–Fr von 09:00–14:00 Uhr erreichbar (0611 – 60 33 13). Unser Büro in der Gaugasse 19 ist Mo–Fr bis 17:00 Uhr besetzt — Termine vor Ort gerne nach Vereinbarung. Zusätzlich haben alle Kunden jederzeit Zugriff auf unser digitales Kundenportal mit Dokumentenablage, Vorgängen und Berichten.'
    },
  ],

  '/weg-verwaltung': [
    {
      question: 'Was macht eine WEG-Verwaltung?',
      answer: 'Eine WEG-Verwaltung übernimmt die kaufmännische, technische und rechtliche Betreuung einer Wohnungseigentümergemeinschaft. Dazu gehören Eigentümerversammlungen, Wirtschaftspläne, Jahresabrechnungen und die Koordination von Instandhaltungsmaßnahmen.'
    },
    {
      question: 'Was kostet eine WEG-Verwaltung pro Einheit?',
      answer: 'Die Kosten variieren je nach Größe und Zustand des Objekts. In der Regel liegen sie zwischen 20 und 35 Euro pro Einheit und Monat. Wir erstellen Ihnen gerne ein individuelles Angebot.'
    },
    {
      question: 'Wie oft finden Eigentümerversammlungen statt?',
      answer: 'Laut WEG-Gesetz muss mindestens einmal jährlich eine ordentliche Eigentümerversammlung stattfinden. Bei Bedarf können zusätzliche außerordentliche Versammlungen einberufen werden.'
    },
    {
      question: 'Was ist der Unterschied zwischen WEG und GdWE?',
      answer: 'Seit der WEG-Reform 2020 heißt es offiziell "Gemeinschaft der Wohnungseigentümer" (GdWE). In der Praxis werden beide Begriffe synonym verwendet. Die Abkürzung WEG bezieht sich auf das Wohnungseigentumsgesetz.'
    },
  ],

  '/verwalter-wechseln': [
    {
      question: 'Wie kann eine WEG ihren Verwalter wechseln?',
      answer: 'Ein Verwalterwechsel erfolgt durch Beschluss der Eigentümerversammlung mit einfacher Mehrheit der abgegebenen Stimmen (§ 26 WEG). In derselben Versammlung wird der bisherige Verwalter abberufen, der Verwaltervertrag gekündigt und die neue Verwaltung bestellt. Den Antrag kann der Verwaltungsbeirat oder mindestens ein Viertel der Eigentümer stellen.'
    },
    {
      question: 'Welche Kündigungsfrist gilt für den Verwaltervertrag?',
      answer: 'Die Abberufung des Verwalters ist nach § 26 Abs. 3 WEG jederzeit möglich, der Verwaltervertrag endet spätestens sechs Monate nach der Abberufung. Oft sieht der Vertrag eine ordentliche Kündigungsfrist von drei bis sechs Monaten vor. Bei einem wichtigen Grund, etwa gravierenden Pflichtverletzungen, ist eine fristlose Kündigung möglich.'
    },
    {
      question: 'Wie lange dauert ein Verwalterwechsel?',
      answer: 'Von der ersten Anfrage bis zur vollständigen Übernahme dauert ein Verwalterwechsel in der Praxis drei bis sechs Monate. Entscheidend sind der Termin der Eigentümerversammlung und die Kündigungsfrist des bestehenden Verwaltervertrags. Die Übergabe der Unterlagen selbst ist meist innerhalb weniger Wochen abgeschlossen.'
    },
    {
      question: 'Was passiert mit den Unterlagen beim Verwalterwechsel?',
      answer: 'Der bisherige Verwalter ist verpflichtet, sämtliche Verwaltungsunterlagen herauszugeben: Konten und Kontovollmachten, Verträge, Versicherungen, Protokolle, Beschlusssammlung, Wirtschaftspläne, Jahresabrechnungen und Schlüssel. Die neue Verwaltung prüft die Übergabe auf Vollständigkeit und fordert fehlende Dokumente nach.'
    },
    {
      question: 'Was kostet ein Verwalterwechsel die Eigentümergemeinschaft?',
      answer: 'Der Wechsel selbst verursacht in der Regel keine zusätzlichen Kosten: Beratung, Angebot, Vorbereitung der Beschlüsse und die Übernahme der Unterlagen sind bei Scholze-Kurz & Kurz kostenfrei. Es fällt lediglich die laufende Verwaltervergütung der neuen Verwaltung an; der Vertrag mit der alten Verwaltung endet mit Ablauf der Kündigungsfrist.'
    },
    {
      question: 'Wie informiert der Beirat die Miteigentümer über den geplanten Wechsel?',
      answer: 'Der Verwaltungsbeirat informiert die Miteigentümer schriftlich über die festgestellten Mängel, den Vorschlag einer neuen Verwaltung und die Tagesordnung der Eigentümerversammlung. Ein kostenloser Musterbrief „Information an alle Eigentümer“ mit allen nötigen Tagesordnungspunkten steht auf dieser Seite zum Kopieren bereit.'
    },
    {
      question: 'Welche Beschlüsse sind für den Verwalterwechsel nötig?',
      answer: 'Erforderlich sind zwei Beschlüsse: die Abberufung des bisherigen Verwalters samt Kündigung des Verwaltervertrags und die Bestellung der neuen Verwaltung samt Genehmigung des neuen Verwaltervertrags. Üblich ist zusätzlich die Bevollmächtigung eines Eigentümers oder des Beirats, den neuen Vertrag im Namen der Gemeinschaft zu unterzeichnen.'
    },
  ],
};

export default seoConfig;
